import React, { useState} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
import ImageUpload from "../../components/imageUpload.js";



const MaTravelPackageCreate = ()=>{
     const [name, setName ] = useState('');
     const [daterange, setDaterange ] = useState('');
     const [totalcost, setTotalcost ] = useState('');
     const [redirect, setRedirect] = useState(false);
     const submit = async (e)=>{
         e.preventDefault();
         const {data} = await axios.post('maTravelPackage', {
            name,
            date_range:daterange,
            total_cost:parseFloat(totalcost),
        });
        console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/maTravelPackage'} />
    }
     return (
         <Wrapper pageTitle={"New MaTravelPackage"}>
            <InnerNav createLink={'/maTravelPackageCreate'} listLink={'/maTravelPackage'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Name </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Name"
                        onChange = {e => setName(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Date Range </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Daterange"
                        onChange = {e => setDaterange(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Total Cost </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Totalcost"
                        onChange = {e => setTotalcost(e.target.value)} />
                    </label>

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default MaTravelPackageCreate;